import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

const BlockEditorContainer = ({
    className,
    children,
}: {
    className?: string;
    children: ReactNode;
}) => {
    return (
        <div
            className={twMerge(
                'grid gap-2 p-2 rounded-xl bg-primary-200 shadow-sm',
                className,
            )}
        >
            {children}
        </div>
    );
};

export default BlockEditorContainer;
